import { useState, ChangeEvent } from "react";
import {
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Button,
  Divider,
  CircularProgress,
} from "@material-ui/core";

import ErrorSharpIcon from "@material-ui/icons/ErrorSharp";
import { RootState, RootDispatch } from "../../model";
import { useRematch } from "../../utils/useRematch";
import GameWinIMG from "../../assets/game-win.png";
import GameLoseIMG from "../../assets/game-lose.png";

import CloseIcon from "@material-ui/icons/Close";

import "./index.less";

const mapState = (state: RootState) => ({
  modalState: { ...state.modal },
  ...state.main,
  loading: state.loading,
});

const mapDispatch = (dispatch: RootDispatch) => ({
  ...dispatch.modal,
  ...dispatch.main,
});

const UNIT_PRICE = 0.08;

export default function GameResultModal() {
  const [
    { modalState, userInfo, loading, saleMintedNum },
    { closeModal, mint },
  ] = useRematch(mapState, mapDispatch);

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={modalState.gameResult.open}
      className="game-result-modal"
      keepMounted
      onClose={closeModal}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <div className="dialog-title">
          <Typography
            variant="h6"
            component="div"
            style={{ fontFamily: '"Montserrat", sans-serif' }}
          >
            {modalState.gameResult.status === 0
              ? "Please wait..."
              : modalState.gameResult.status === 1
              ? modalState.gameResult.isGift
                ? "Congratulations !"
                : "Maybe next time !"
              : "Network error, please try again"}
          </Typography>
          {modalState.gameResult.status !== 0 && (
            <IconButton aria-label="close" onClick={closeModal}>
              <CloseIcon />
            </IconButton>
          )}
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-slide-description"
          component="div"
          className="result-container"
        >
          {modalState.gameResult.status === 0 ? (
            <CircularProgress color="secondary" size={60} />
          ) : modalState.gameResult.status === 1 ? (
            modalState.gameResult.isGift ? (
              <img src={GameWinIMG} width="80%" alt="" />
            ) : (
              <img src={GameLoseIMG} width="80%" alt="" />
            )
          ) : (
            <ErrorSharpIcon style={{ fontSize: 60, color: "red" }} />
          )}
          <div className="status-text">
            {modalState.gameResult.status === 0
              ? "Verifying coordinates..."
              : modalState.gameResult.status === 1
              ? modalState.gameResult.isGift
                ? `Congratulations! \n You won one point, Keep up the good work!`
                : "Unfortunately, You almost found the Treasure ! \n Please wait for the next chance to try again!"
              : modalState.gameResult.errorMsg || "Please try again."}
          </div>
        </DialogContentText>
        <Divider variant="middle" />
        <DialogActions>
          <Button
            disabled={modalState.gameResult.status === 0}
            onClick={closeModal}
          >
            OK
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}
